export default {
  apply: {
    title: 'Apply for Prepaid Membership',
    button: 'Apply for Prepaid Membership',
    viewLedger: 'View Ledger'
  },
  terms: {
    title: 'Prepaid Membership Terms of Service',
    subtitle: 'Please read the following terms carefully before proceeding',
    agree: 'I have read and agree to the terms above',
    continue: 'Continue',
    back: 'Back',
    content: {
      section1: {
        title: '1. Service Description',
        items: [
          'Prepaid membership operates on a prepayment system. Customers must top up before using the balance for rentals.',
          'The balance consists of two parts: "Paid Amount" and "Bonus Amount".',
          'Paid Amount is the actual amount paid by the customer and can be invoiced; Bonus Amount is issued by the platform and is non-refundable.'
        ]
      },
      section2: {
        title: '2. Top-up Rules',
        items: [
          'Top-up plans are set by the platform. Customers may choose a suitable plan to apply.',
          'Applications must be reviewed and approved by the store manager, with payment completed on-site to activate the account.',
          'The balance will be credited immediately after payment is confirmed.'
        ]
      },
      section3: {
        title: '3. Usage Rules',
        items: [
          'Once an order is confirmed, the system will automatically deduct from the prepaid account.',
          'Deduction order: Paid Amount is deducted first; Bonus Amount is used when Paid Amount is insufficient.',
          'Invoices will be issued for Paid Amount consumption; Bonus Amount consumption is not invoiced.',
          'When the balance falls below NT$3,000, the system will prompt you to top up.'
        ]
      },
      section4: {
        title: '4. Refund Policy',
        items: [
          'Paid Amount may be refunded, but the Paid Amount equivalent of any used Bonus Amount will be deducted.',
          'Bonus Amount is non-refundable and non-transferable.',
          'When exiting prepaid membership, the Paid Amount balance must be zero.'
        ]
      },
      section5: {
        title: '5. Other Notes',
        items: [
          'Prepaid balances cannot be transferred to other customers.',
          'The platform reserves the right to modify top-up plans without affecting existing balances.',
          'For any questions, please contact customer service.'
        ]
      }
    }
  },
  plans: {
    title: 'Choose a Top-up Plan',
    subtitle: 'Select the plan that works best for you and enjoy extra value',
    realAmount: 'Top-up Amount',
    bonusAmount: 'Bonus Amount',
    totalAmount: 'Total Value',
    bonusRate: 'Bonus Rate',
    select: 'Select This Plan',
    selected: 'Selected',
    popular: 'Popular',
    recommended: 'Recommended'
  },
  application: {
    title: 'Confirm Application',
    subtitle: 'Please review your application details. Once submitted, it will enter the review process.',
    selectedPlan: 'Selected Plan',
    customerInfo: 'Customer Information',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    notes: 'Notes (optional)',
    notesPlaceholder: 'If you have any special requests, please note them here...',
    agreeTerms: 'I have read and agree to the terms of service',
    submit: 'Submit Application',
    submitting: 'Submitting...',
    back: 'Back',
    success: 'Application Submitted!',
    successMessage: 'Your application has been submitted. Please wait for admin review. Once approved, visit us in person to complete payment and activate your account.',
    error: 'Application Failed',
    errorMessage: 'An error occurred while submitting your application. Please try again.'
  },
  status: {
    pending: 'Pending Review',
    approved: 'Approved',
    rejected: 'Rejected',
    paid: 'Paid',
    cancelled: 'Cancelled',
    pendingDesc: 'Your application is under review, please wait',
    approvedDesc: 'Application approved. Please visit us in person to complete payment.',
    rejectedDesc: 'Application was not approved',
    paidDesc: 'Payment complete. Your prepaid account is now active.',
    cancelledDesc: 'Application cancelled'
  },
  myApplication: {
    title: 'My Application',
    noApplication: 'No application on record',
    appliedAt: 'Applied At',
    reviewedAt: 'Reviewed At',
    paymentAt: 'Paid At',
    plan: 'Plan',
    status: 'Status',
    notes: 'Notes',
    rejectionReason: 'Rejection Reason',
    viewDetails: 'View Details'
  },
  ledger: {
    title: 'Prepaid Ledger',
    subtitle: 'View your prepaid balance and transaction history',
    accountBalance: 'Account Balance',
    realBalance: 'Paid Amount',
    bonusBalance: 'Bonus Amount',
    totalBalance: 'Total Balance',
    statistics: 'Statistics',
    totalDeposited: 'Total Deposited',
    totalBonus: 'Total Bonus',
    totalSpent: 'Total Spent',
    lowBalanceWarning: 'Low Balance',
    lowBalanceMessage: 'Your prepaid balance is below NT$3,000. We recommend topping up to avoid disruptions.',
    recharge: 'Top Up Now',
    transactions: 'Transaction History',
    noTransactions: 'No transactions yet',
    date: 'Date',
    type: 'Type',
    amount: 'Amount',
    balance: 'Balance',
    description: 'Description',
    viewOrder: 'View Order',
    deposit: 'Top-up',
    deduct: 'Deduction',
    refund: 'Refund',
    bonus: 'Bonus',
    adjustment: 'Adjustment'
  },
  common: {
    loading: 'Loading...',
    error: 'An error occurred',
    retry: 'Retry',
    close: 'Close',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    currency: 'NT$'
  }
};
